module.exports = __webpack_public_path__ + "media/images/landing_pages/hot_pet-0b3993815cedb84951bd6e27d9a3c0b6.svg";